import React from 'react'
import Image from 'next/image'
import { CarouselSlideProps } from '~types'
import { Modal } from '~elements'
import styles from './CarouselSlide.module.scss'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { useWindowSize } from 'utils/hooks'
import { useModal } from 'utils/hooks/useModal'

const CarouselSlide = ({
  imageTitle: title,
  imageDescription: description,
  openImageInModal = false,
  defaultImg: defaultImage,
  mobileImage
}: CarouselSlideProps) => {
  const { isBreakpoint: isBelowBreakpointSm } = useWindowSize('sm', '<')
  const responsiveImage = isBelowBreakpointSm ? mobileImage : defaultImage
  const { image } = responsiveImage || {}
  const { isModalOpen, openModal, closeModal } = useModal()

  const ImageComponent = () => {
    return image?.url ? (
      <Image
        src={image.url}
        alt={image.altText || ''}
        width={image.width}
        height={image.height}
        quality={NEXT_IMAGE_QUALITY}
        style={{
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain'
        }}
      />
    ) : null
  }

  const handleImageClick = () => {
    openImageInModal && openModal()
  }

  return (
    <div className={styles.slide}>
      <div className={styles['image-container']} onClick={handleImageClick}>
        <ImageComponent />
      </div>
      <p>{title}</p>
      {description && <p>{description}</p>}
      {isModalOpen && (
        <Modal handleModalClose={closeModal} isOpen={isModalOpen} width='content-aware' backgroundColor='gray-900'>
          <ImageComponent />
        </Modal>
      )}
    </div>
  )
}

export default CarouselSlide
